(function ($) {
	function modalBox() {
		var modal = $('.u-modal-overlay'),
			urlPath = $(location).attr('pathname'),
			code = gup('code', window.location.href);

		$('.modal-open').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var id = $(this).data('id'),
				number = $(
					'.u-modal-overlay[data-id="' + id + '"] .mobile a'
				).data('number');

			$('.u-modal-overlay[data-id="' + id + '"]').fadeIn(500);

			if ($(this).hasClass('modal-open-country')) {
				if (!code) {
					window.history.replaceState(
						null,
						// @ts-ignore-next
						null,
						'?country=' + id + '&code='
					);
				} else {
					window.history.replaceState(
						null,
						// @ts-ignore-next
						null,
						'?country=' + id + '&code=' + code
					);
					$('.u-modal-overlay .mobile a').attr(
						'href',
						'tel:' + number + ';' + code
					);
				}
			}
		});

		$('.modal-close-area, .modal-close').on('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			modal.fadeOut(500);
			// @ts-ignore-next
			window.history.replaceState(null, null, urlPath);
		});

		$(document).on('keyup', function (e) {
			e.preventDefault();
			e.stopPropagation();
			if (e.keyCode == 27) {
				modal.fadeOut(500);
			}
		});
	}
	modalBox();

	function showModal() {
		var country = gup('country', window.location.href),
			code = gup('code', window.location.href);

		if (
			country &&
			$('.u-modal-overlay[data-id="' + country + '"]').length > 0
		) {
			$('.u-modal-overlay[data-id="' + country + '"]').fadeIn(500);

			if (code) {
				// $('.u-modal-overlay[data-id="'+country+'"] .code span').text(code);
				// $('.u-modal-overlay[data-id="'+country+'"] .mobile strong').text(code);
				// $('.u-modal-overlay[data-id="'+country+'"] .mobile a').attr('href', "tel:" + number + ";" + code );

				var number = $(
					'.u-modal-overlay[data-id="' + country + '"] .mobile a'
				).data('number');

				$('.u-modal-overlay .code span').text(code);
				$('.u-modal-overlay .mobile strong').text(code);
				$('.u-modal-overlay .mobile a').attr(
					'href',
					'tel:' + number + ';' + code
				);
			}
		}

		if (code && !country) {
			$(
				'.u-modal-overlay .code span, .u-modal-overlay .mobile strong'
			).text(code);
		}
	}

	// @ts-ignore-next
	function gup(name, url) {
		if (!url) url = location.href;
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regexS = '[\\?&]' + name + '=([^&#]*)';
		var regex = new RegExp(regexS);
		var results = regex.exec(url);
		return results == null ? null : results[1];
	}

	showModal();
})(jQuery);
